<template>
    <div class="subcategories-types">
        <div v-for="childCategory in childCategoriesMapped" :key="childCategory.id" class="subcategories-type">
            <span
                v-if="childCategory.linkDisabled"
                :title="childCategory.name"
                class="subcategories-type-text text-uppercase disabled"
            >
                {{ childCategory.title }} (0)
            </span>
            <a
                v-else
                :href="childCategory.linkWithFilters"
                :title="childCategory.name"
                class="subcategories-type-text text-uppercase"
            >
                {{ childCategory.title }}
                ({{ childCategory.activeProductCount }})
            </a>
        </div>
        <div v-if="backLinkWithFilter" class="subcategories-type return">
            <a
                :href="backLinkWithFilter"
                :title="category.activeOrderedParentCategories[0].name"
                class="subcategories-type-text text-uppercase subcategories-return-button"
            >
                {{ __('frontend_js.category.back-to') }}
                {{ category.activeOrderedParentCategories[0].title }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        category: { required: true },
        isThirdLevelCategory: { required: true, type: Boolean },
        categoryNumbers: {},
        // subcategoriesCountFromView: { required: true, type: Object },
    },
    data() {
        return {
            categoryData: this.category,
            counts: this.categoryNumbers,
        };
    },
    computed: {
        queryFilters() {
            return this.$store.getters['product-filters/queryFilters'];
        },
        queryParams() {
            return this.queryFilters ? '/f/' + this.queryFilters : '';
        },
        /**
         * Maps child categories with product numbers which are shown in brackets.
         * Important change why this cannot come from BE are filters and query params
         */
        childCategoriesMapped() {
            return this.category.activeOrderedChildCategories
                .filter(c => c.isOnStock == true)
                .map(category => {
                    const linkDisabled = this.categoryNumbers[category.id] <= 0;
                    const resultCount = this.categoryNumbers[category.id];
                    return {
                        ...category,
                        linkWithFilters: '/' + category.slug + this.queryParams,
                        resultCount,
                        linkDisabled,
                    };
                });
        },
        /**
         * Creates link for child category with applied filters for customers
         * to be able to redirect back and not lose their applied filters
         */
        backLinkWithFilter() {
            if (
                this.isThirdLevelCategory ||
                (this.isThirdLevelCategory && this.categoryData.activeOrderedParentCategories[0].template === 'products')
            ) {
                const link = '/' + this.categoryData.activeOrderedParentCategories[0].slug;
                return link + this.queryParams;
            }

            return null;
        },
    },
    created() {
        /**Loads new number for each category after filters are applied */
        this.$root.$on('itemsLoaded', response => (this.counts = response.data.filterData.categoryNumbers));
        // this.$root.$on('itemsLoaded', response => console.log(response.data.filterData));
        this.$store.commit('product-list/SET_TOTAL_PRODUCTS', this.category.activeProductCount);
    },
};
</script>
